module.exports = __webpack_public_path__ + "img/comodin-50.62aeb909.png";